import React from 'react';
import config from 'src/config';
import Modal from 'src/shared/components/modal/Modal';
import { PrimaryButton } from 'src/shared/components/button/Button';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';

type BookCallModalProps = {
    onClose: () => void;
};

const BookCallModal = ({ onClose }: BookCallModalProps) => {
    return (
        <Modal
            onClose={onClose}
            dismissOnClickOutside={true}
            classNames={{
                body: 'w-[625px]',
            }}
        >
            <div className='flex flex-col gap-3'>
                <div className='text-primary text-xl items-center'>Book a call</div>
                <div className='text-sm'>
                    <CMSArticle slug='book-a-call-popup' />
                </div>
                <PrimaryButton
                    className='w-fit place-self-end'
                    onClick={() => {
                        const newWindow = window.open(config.bookDemoCallFormUrl, '_blank', 'noopener,noreferrer');
                        if (newWindow) {
                            newWindow.opener = null;
                        }
                    }}
                >
                    Book a call
                </PrimaryButton>
            </div>
        </Modal>
    );
};

export default BookCallModal;
